export default function MemoryFlowchart() {
  return (
    <div className="text-center">
      <svg
        width="1000"
        height="600"
        viewBox="0 0 1000 600"
        style={{
          maxWidth: "100%",
          height: "auto",
          display: "block",
          margin: "0 auto",
        }}
      >
        {/* Define arrow marker for start of line */}
        <defs>
          <marker
            id="arrowhead"
            markerWidth="12"
            markerHeight="8"
            refX="11"
            refY="4"
            orient="auto"
            markerUnits="strokeWidth"
          >
            <polygon points="0 0, 12 4, 0 8" fill="#333" stroke="#333" />
          </marker>
          <marker
            id="arrowhead-start"
            markerWidth="12"
            markerHeight="8"
            refX="1"
            refY="4"
            orient="auto"
            markerUnits="strokeWidth"
          >
            <polygon points="12 0, 0 4, 12 8" fill="#333" stroke="#333" />
          </marker>
        </defs>

        {/* Central Memory circle */}
        <circle cx="200" cy="300" r="80" fill="white" stroke="#333" strokeWidth="3" />
        <text x="200" y="305" textAnchor="middle" fontSize="18" fontWeight="bold" fill="#333">
          Memory
        </text>

        {/* Immediate word recall box */}
        <rect x="400" y="40" width="180" height="60" fill="white" stroke="#333" strokeWidth="2" />
        <text x="490" y="73" textAnchor="middle" fontSize="14" fontWeight="bold" fill="#333">
          Immediate word recall
        </text>

        {/* Delayed word recall box */}
        <rect x="400" y="130" width="180" height="60" fill="white" stroke="#333" strokeWidth="2" />
        <text x="490" y="163" textAnchor="middle" fontSize="14" fontWeight="bold" fill="#333">
          Delayed word recall
        </text>

        {/* Visual memory box */}
        <rect x="400" y="220" width="180" height="60" fill="white" stroke="#333" strokeWidth="2" />
        <text x="490" y="253" textAnchor="middle" fontSize="14" fontWeight="bold" fill="#333">
          Visual memory
        </text>

        {/* Story recall box */}
        <rect x="400" y="310" width="180" height="60" fill="white" stroke="#333" strokeWidth="2" />
        <text x="490" y="343" textAnchor="middle" fontSize="14" fontWeight="bold" fill="#333">
          Story recall
        </text>

        {/* Working memory box */}
        <rect x="400" y="400" width="180" height="60" fill="white" stroke="#333" strokeWidth="2" />
        <text x="490" y="433" textAnchor="middle" fontSize="14" fontWeight="bold" fill="#333">
          Working memory
        </text>

        {/* Semantic memory box */}
        <rect x="400" y="490" width="180" height="60" fill="white" stroke="#333" strokeWidth="2" />
        <text x="490" y="523" textAnchor="middle" fontSize="14" fontWeight="bold" fill="#333">
          Semantic memory
        </text>

        {/* Arrows from Memory to each component */}
        {/* To Immediate word recall */}
        <line x1="260" y1="240" x2="385" y2="80" stroke="#333" strokeWidth="2" markerEnd="url(#arrowhead)" />

        {/* To Delayed word recall */}
        <line x1="270" y1="260" x2="385" y2="160" stroke="#333" strokeWidth="2" markerEnd="url(#arrowhead)" />

        {/* Two-way curved arrow between Immediate and Delayed word recall */}
        <path
          d="M 590 80 Q 630 90 630 115 Q 630 140 590 150"
          fill="none"
          stroke="#333"
          strokeWidth="2"
          markerEnd="url(#arrowhead)"
          markerStart="url(#arrowhead-start)"
        />

        {/* To Visual memory */}
        <line x1="280" y1="290" x2="385" y2="250" stroke="#333" strokeWidth="2" markerEnd="url(#arrowhead)" />

        {/* To Story recall */}
        <line x1="280" y1="320" x2="385" y2="340" stroke="#333" strokeWidth="2" markerEnd="url(#arrowhead)" />

        {/* To Working memory */}
        <line x1="270" y1="350" x2="385" y2="430" stroke="#333" strokeWidth="2" markerEnd="url(#arrowhead)" />

        {/* To Semantic memory */}
        <line x1="260" y1="370" x2="385" y2="520" stroke="#333" strokeWidth="2" markerEnd="url(#arrowhead)" />
      </svg>
    </div>
  );
}
